export const OAuthSettings = {
    appId: '003920c3-389f-41c5-9c37-8bdd68818b84',
    tenentId: '3dd69d95-c642-44a2-99cd-df33ea680f12',
    scopes: [
      "user.read",
      "calendars.read"
    ]
  };
